// Definición de defaults

export const defaultObjetoExhorto: ObjetoExhortoProps = {
    idObjetoExhorto:    0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface ObjetoExhortoProps {
    idObjetoExhorto:        number;
    descripcion:             string;
    activo:                  boolean;
}